import { atom } from 'jotai'

export type ReflectionResponseSummaryData = {
  userId: string
  responseId: string
  response?: string
}

export const currentReflectionSummaryDataAtom = atom<ReflectionResponseSummaryData[]>([])
